<template>
  <DataTable :headers="headers" :path="path" :filterPath="filterPath" actionButtonsName="ExpirationActionButtons"
             :properties="properties" :defaults="defaults" filter>
    <slot slot="before-filters"></slot>
  </DataTable>
</template>

<script>
import DataTable from '../../../common/ui/DataTable'
import { expirationMixin } from '../../../mixins/expirationMixin'

export default {
  mixins: [expirationMixin],

  components: {
    DataTable
  }
}
</script>
